import { getStateAtNamespaceKey } from 'redux/get-state-at-namespace-key';

export const getCheckout = (state: WtrState) => getStateAtNamespaceKey(state, 'checkout');
